import helppesLogo from "Assets/Images/Campaigns/Helppes/logo.png";
import ambulanceLogo from "Assets/Images/Campaigns/Ambulance/logo.png";
import hummingbirdLogo from "Assets/Images/Campaigns/Hummingbird/logo.png";
import mcdonaldLogo from "Assets/Images/Campaigns/McDonald/logo.png";
import animalrescueLogo from "Assets/Images/Campaigns/AnimalRescue/logo.png";

type CampaignLogoConfig = {
  src: string;
  width?: number;
  height?: number;
};

const CAMPAIGN_LOGOS: Record<string, CampaignLogoConfig> = {
  helppes: {
    src: helppesLogo,
    width: 45,
    height: 45,
  },
  sanitka: {
    src: ambulanceLogo,
    width: 45,
    height: 45,
  },
  kolibrici: {
    src: hummingbirdLogo,
    width: 45,
    height: 45,
  },
  mcdonald: {
    src: mcdonaldLogo,
    width: 45,
    height: 45,
  },
  "ochrana-zvirat": {
    src: animalrescueLogo,
    width: 97,
    height: 33,
  },
};

export type CampaignLogoData = {
  src: string;
  alt: string;
  width?: number;
  height?: number;
};

/**
 * Gets campaign logo data based on campaign code
 * @param campaignCode - The campaign code (e.g., "helppes")
 * @returns Campaign logo data or undefined if campaign not found
 */
export const getCampaignLogo = (
  campaignCode: string | null | undefined,
): CampaignLogoData | undefined => {
  if (!campaignCode) {
    return undefined;
  }

  const logoConfig = CAMPAIGN_LOGOS[campaignCode.toLowerCase()];

  if (!logoConfig) {
    return undefined;
  }

  const { src, width, height } = logoConfig;

  return { src, alt: campaignCode, width, height };
};
